module.exports = __webpack_public_path__ + "static/media/protects.f7d8e005.mp3";